const SHAPES: Record<
  string,
  (c: { bg: string; rect: string; circle: string; line: string }, uid: string) => string
> = {
  A: (c, uid) =>
    `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" width="80" height="80"><mask id="${uid}" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80"><rect width="80" height="80" rx="160" fill="#FFF"/></mask><g mask="url(#${uid})"><rect width="80" height="80" fill="${c.bg}"/><rect x="10" y="30" width="80" height="80" fill="${c.rect}" transform="translate(-8 -8) rotate(320 40 40)"/><circle cx="40" cy="40" fill="${c.circle}" r="16" transform="translate(-3 -3)"/><line x1="0" y1="40" x2="80" y2="40" stroke-width="2" stroke="${c.line}" transform="rotate(280 40 40)"/></g></svg>`,
  B: (c, uid) =>
    `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" width="80" height="80"><mask id="${uid}" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80"><rect width="80" height="80" rx="160" fill="#FFF"/></mask><g mask="url(#${uid})"><rect width="80" height="80" fill="${c.bg}"/><rect x="10" y="30" width="80" height="10" fill="${c.rect}" transform="translate(16 -16) rotate(336 40 40)"/><circle cx="40" cy="40" fill="${c.circle}" r="16" transform="translate(-18 18)"/><line x1="0" y1="40" x2="80" y2="40" stroke-width="2" stroke="${c.line}" transform="translate(12 12) rotate(312 40 40)"/></g></svg>`,
  C: (c, uid) =>
    `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" width="80" height="80"><mask id="${uid}" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80"><rect width="80" height="80" rx="160" fill="#FFF"/></mask><g mask="url(#${uid})"><rect width="80" height="80" fill="${c.bg}"/><rect x="10" y="30" width="80" height="10" fill="${c.rect}" transform="translate(6 -6) rotate(130 40 40)"/><circle cx="40" cy="40" fill="${c.circle}" r="16" transform="translate(12 12)"/><line x1="0" y1="40" x2="80" y2="40" stroke-width="2" stroke="${c.line}" transform="rotate(260 40 40)"/></g></svg>`,
  D: (c, uid) =>
    `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" width="80" height="80"><mask id="${uid}" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80"><rect width="80" height="80" rx="160" fill="#FFF"/></mask><g mask="url(#${uid})"><rect width="80" height="80" fill="${c.bg}"/><rect x="10" y="30" width="80" height="10" fill="${c.rect}" transform="translate(2 -2) rotate(176 40 40)"/><circle cx="40" cy="40" fill="${c.circle}" r="16" transform="translate(-9 9)"/><line x1="0" y1="40" x2="80" y2="40" stroke-width="2" stroke="${c.line}" transform="translate(12 12) rotate(352 40 40)"/></g></svg>`,
  E: (c, uid) =>
    `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" width="80" height="80"><mask id="${uid}" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80"><rect width="80" height="80" rx="160" fill="#FFF"/></mask><g mask="url(#${uid})"><rect width="80" height="80" fill="${c.bg}"/><rect x="10" y="30" width="80" height="80" fill="${c.rect}" transform="translate(-6 6) rotate(240 40 40)"/><circle cx="40" cy="40" fill="${c.circle}" r="16" transform="translate(-18 -18)"/><line x1="0" y1="40" x2="80" y2="40" stroke-width="2" stroke="${c.line}" transform="rotate(120 40 40)"/></g></svg>`,
  F: (c, uid) =>
    `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" width="80" height="80"><mask id="${uid}" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80"><rect width="80" height="80" rx="160" fill="#FFF"/></mask><g mask="url(#${uid})"><rect width="80" height="80" fill="${c.bg}"/><rect x="10" y="30" width="80" height="10" fill="${c.rect}" transform="translate(-16 -16) rotate(126 40 40)"/><circle cx="40" cy="40" fill="${c.circle}" r="16" transform="translate(-3 -3)"/><line x1="0" y1="40" x2="80" y2="40" stroke-width="2" stroke="${c.line}" transform="translate(12 12) rotate(252 40 40)"/></g></svg>`,
  G: (c, uid) =>
    `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" width="80" height="80"><mask id="${uid}" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80"><rect width="80" height="80" rx="160" fill="#FFF"/></mask><g mask="url(#${uid})"><rect width="80" height="80" fill="${c.bg}"/><rect x="10" y="30" width="80" height="80" fill="${c.rect}" transform="translate(8 8) rotate(92 40 40)"/><circle cx="40" cy="40" fill="${c.circle}" r="16" transform="translate(18 18)"/><line x1="0" y1="40" x2="80" y2="40" stroke-width="2" stroke="${c.line}" transform="translate(-4 -4) rotate(184 40 40)"/></g></svg>`,
  H: (c, uid) =>
    `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" width="80" height="80"><mask id="${uid}" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80"><rect width="80" height="80" rx="160" fill="#FFF"/></mask><g mask="url(#${uid})"><rect width="80" height="80" fill="${c.bg}"/><rect x="10" y="30" width="80" height="10" fill="${c.rect}" transform="translate(8 -8) rotate(338 40 40)"/><circle cx="40" cy="40" fill="${c.circle}" r="16" transform="translate(-12 -12)"/><line x1="0" y1="40" x2="80" y2="40" stroke-width="2" stroke="${c.line}" transform="translate(16 16) rotate(316 40 40)"/></g></svg>`,
  I: (c, uid) =>
    `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" width="80" height="80"><mask id="${uid}" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80"><rect width="80" height="80" rx="160" fill="#FFF"/></mask><g mask="url(#${uid})"><rect width="80" height="80" fill="${c.bg}"/><rect x="10" y="30" width="80" height="80" fill="${c.rect}" transform="translate(10 10) rotate(310 40 40)"/><circle cx="40" cy="40" fill="${c.circle}" r="16" transform="translate(-12 -12)"/><line x1="0" y1="40" x2="80" y2="40" stroke-width="2" stroke="${c.line}" transform="rotate(260 40 40)"/></g></svg>`,
  J: (c, uid) =>
    `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" width="80" height="80"><mask id="${uid}" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80"><rect width="80" height="80" rx="160" fill="#FFF"/></mask><g mask="url(#${uid})"><rect width="80" height="80" fill="${c.bg}"/><rect x="10" y="30" width="80" height="80" fill="${c.rect}" transform="translate(-6 6) rotate(80 40 40)"/><circle cx="40" cy="40" fill="${c.circle}" r="16" transform="translate(-3 3)"/><line x1="0" y1="40" x2="80" y2="40" stroke-width="2" stroke="${c.line}" transform="rotate(160 40 40)"/></g></svg>`,
};

const AVATARS = [
  {
    id: "gfg-01",
    shape: "A",
    colors: { bg: "#C2553A", rect: "#F2E6D0", circle: "#3A7CA5", line: "#D49B2B" },
  },
  {
    id: "gfg-02",
    shape: "A",
    colors: { bg: "#9E4B5E", rect: "#F2E6D0", circle: "#5A8C6A", line: "#B87D3A" },
  },
  {
    id: "gfg-03",
    shape: "B",
    colors: { bg: "#2B7A7E", rect: "#3D342F", circle: "#D06B50", line: "#F2E6D0" },
  },
  {
    id: "gfg-04",
    shape: "B",
    colors: { bg: "#3A7CA5", rect: "#3D342F", circle: "#5A8C6A", line: "#D49B2B" },
  },
  {
    id: "gfg-05",
    shape: "C",
    colors: { bg: "#D06B50", rect: "#F2E6D0", circle: "#2B7A7E", line: "#B87D3A" },
  },
  {
    id: "gfg-06",
    shape: "C",
    colors: { bg: "#B87D3A", rect: "#F2E6D0", circle: "#C2553A", line: "#2B7A7E" },
  },
  {
    id: "gfg-07",
    shape: "D",
    colors: { bg: "#D49B2B", rect: "#3D342F", circle: "#2B7A7E", line: "#F2E6D0" },
  },
  {
    id: "gfg-08",
    shape: "D",
    colors: { bg: "#5A8C6A", rect: "#3D342F", circle: "#D06B50", line: "#F2E6D0" },
  },
  {
    id: "gfg-09",
    shape: "E",
    colors: { bg: "#3A7CA5", rect: "#F2E6D0", circle: "#9E4B5E", line: "#C2553A" },
  },
  {
    id: "gfg-10",
    shape: "E",
    colors: { bg: "#2B7A7E", rect: "#F2E6D0", circle: "#D49B2B", line: "#9E4B5E" },
  },
  {
    id: "gfg-11",
    shape: "F",
    colors: { bg: "#5A8C6A", rect: "#3D342F", circle: "#B87D3A", line: "#F2E6D0" },
  },
  {
    id: "gfg-12",
    shape: "F",
    colors: { bg: "#9E4B5E", rect: "#3D342F", circle: "#D49B2B", line: "#F2E6D0" },
  },
  {
    id: "gfg-13",
    shape: "G",
    colors: { bg: "#F2E6D0", rect: "#5A8C6A", circle: "#2B7A7E", line: "#3D342F" },
  },
  {
    id: "gfg-14",
    shape: "G",
    colors: { bg: "#F2E6D0", rect: "#D06B50", circle: "#B87D3A", line: "#3D342F" },
  },
  {
    id: "gfg-15",
    shape: "H",
    colors: { bg: "#3D342F", rect: "#C2553A", circle: "#F2E6D0", line: "#5A8C6A" },
  },
  {
    id: "gfg-16",
    shape: "H",
    colors: { bg: "#3D342F", rect: "#D49B2B", circle: "#F2E6D0", line: "#2B7A7E" },
  },
  {
    id: "gfg-17",
    shape: "I",
    colors: { bg: "#C2553A", rect: "#F2E6D0", circle: "#3A7CA5", line: "#D49B2B" },
  },
  {
    id: "gfg-18",
    shape: "I",
    colors: { bg: "#D49B2B", rect: "#F2E6D0", circle: "#9E4B5E", line: "#5A8C6A" },
  },
  {
    id: "gfg-19",
    shape: "J",
    colors: { bg: "#2B7A7E", rect: "#F2E6D0", circle: "#D06B50", line: "#B87D3A" },
  },
  {
    id: "gfg-20",
    shape: "J",
    colors: { bg: "#D06B50", rect: "#F2E6D0", circle: "#5A8C6A", line: "#3A7CA5" },
  },
];

interface GfgAvatarProps {
  /** Deterministic seed — use note.id so the same note always gets the same avatar */
  seed: number;
  size?: number;
}

const GfgAvatar = ({ seed, size = 48 }: GfgAvatarProps) => {
  const DEFAULT_AVATAR = {
    id: "gfg-01",
    shape: "A",
    colors: { bg: "#C2553A", rect: "#F2E6D0", circle: "#3A7CA5", line: "#D49B2B" },
  };

  const avatar = AVATARS.length ? AVATARS[Math.abs(seed) % AVATARS.length] : DEFAULT_AVATAR;
  const shapeFn = SHAPES[avatar?.shape ?? "A"] ?? SHAPES?.A;
  const safeAvatar = avatar ?? DEFAULT_AVATAR;
  const svgString =
    shapeFn?.(safeAvatar.colors, safeAvatar.id)
      ?.replace(/width="80"/, `width="${size}"`)
      ?.replace(/height="80"/, `height="${size}"`) ?? "";

  const dataUrl = svgString ? `data:image/svg+xml,${encodeURIComponent(svgString)}` : "";

  return (
    <img
      src={dataUrl}
      alt=""
      width={size}
      height={size}
      style={{ display: "block", flexShrink: 0 }}
    />
  );
};

export default GfgAvatar;
